import React from 'react'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import type { SxProps, Theme } from '@mui/material/styles'
import { Link } from 'react-router-dom'
import DashboardIcon from '@mui/icons-material/Dashboard'

const cardActionSx: SxProps<Theme> = theme => ({
  borderRadius: theme.shape.borderRadius,
  '& .MuiCardActionArea-focusHighlight': { opacity: 0 },
  '&:focus-visible': {
    outline: `3px solid ${theme.palette.primary.main}`,
    outlineOffset: 2
  }
})

const primaryBtnSx: SxProps<Theme> = theme => ({
  minHeight: 56,
  textTransform: 'none',
  fontSize: 18,
  px: 3
})

export interface NavCardProps {
  to: string
  title: string
  subtitle?: string
  actionLabel?: string
  icon?: React.ReactNode
}

const NavCard: React.FC<NavCardProps> = ({
  to,
  title,
  subtitle,
  actionLabel = 'Open',
  icon
}) => {
  return (
    <Card variant='outlined' sx={{ height: '100%' }}>
      <CardActionArea component={Link} to={to} sx={cardActionSx}>
        <CardHeader
          avatar={icon || <DashboardIcon />}
          title={<Typography variant='h6'>{title}</Typography>}
          subheader={subtitle}
        />
        <CardContent>
          <Typography variant='body2' color='text.secondary'>
            Quick access to {title}.
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions sx={{ p: 2, pt: 0 }}>
        <Button
          component={Link}
          to={to}
          variant='contained'
          sx={primaryBtnSx}
          aria-label={`Go to ${title}`}
        >
          {actionLabel}
        </Button>
      </CardActions>
    </Card>
  )
}

export default NavCard
